import { BasicRequest } from "./basicRequest";

export class ChangePasswordRequest extends BasicRequest{
    
    public oldPwd! : string;
    public newPwd! : string;

    constructor(){
        super();
    }
}